define( [
	"../var/support"
], function( support ) {

"use strict";

support.focusin = "onfocusin" in window;

return support;

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/event/support.js
// module id = 563
// module chunks = 0